import { GetLocal } from "../utilities/AxiosUtility";
import { localPort, version } from "../utilities/Constants";
import Cookie, { removeSession } from "../utilities/CookieUtility";

export default class Refresh {
  static async sendCommand(cardNo) {
    const response = await GetLocal(
      `${localPort}/${version}/ddish/innerRefresh/${cardNo}`
    );
    // console.log({ response });
    if (response && response.data.issuccess === true) {
      return "success";
    } else {
      if (response.data.resultMessage == "token has been expired") {
        Cookie.remove("auth");
        window.location.reload();
      }
      return "failed";
    }
  }
}
